import TemplateCategory from "../../../models/TemplateCategory";
import TextInputWithError from "../../inputs/TextInputWithError";
import SelectWithError, {
  SelectWithError as RawSelectWithError,
} from "../SelectWithError";
import { getOptionsFromSchema } from "../utils";
import { scopeIdInput } from "./index";

export default {
  specCategoryName: {
    InputComponent: TextInputWithError,
    label: "Template Name",
    name: "name",
    fullWidth: true,
    required: true,
  },
  specCategoryType: {
    InputComponent: RawSelectWithError,
    label: "Select Type",
    name: "type",
    options: getOptionsFromSchema("SpecCategory", "types"),
    required: true,
    fullWidth: true,
  },
  specCategoryKey: {
    InputComponent: RawSelectWithError,
    label: "Select Template Type",
    name: "key",
    options: getOptionsFromSchema("SpecCategory", "keys"),
    nullAsEmpty: true,
    fullWidth: true,
  },
  specCategoryDetailName: {
    InputComponent: TextInputWithError,
    name: "name",
    label: "Add Title",
    fullWidth: true,
    autoFocus: true,
  },
  isActive: {
    InputComponent: RawSelectWithError,
    label: "Status",
    name: "isActive",
    options: [
      { id: true, name: "Active" },
      { id: false, name: "Inactive" },
    ],
    displayEmpty: false,
    fullWidth: true,
  },
  templateCategoryId: {
    InputComponent: SelectWithError,
    label: "Template Category",
    name: "templateCategoryId",
    dataComponentId: "select-template-categories",
    isSingleAutocomplete: true,
    isAutocomplete: true,
    APIOptions: {
      model: TemplateCategory,
      route: "template-categories",
      sort: [{ columnName: "name", direction: "asc" }],
      pageSize: -1,
      fetchOnlyOnce: true,
      omitDestroyDataComponent: true,
    },
    fullWidth: true,
    required: false,
    valueProperty: "id",
    labelProperty: "name",
    apiFilterLabelProperty: "name",
  },
  scopeId: scopeIdInput,
};
